import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '~/components/modals/liquid-granular-info/liquid-granular-info.module.scss';

const LiquidGranularInfoModal = ({ onClose, isOpen }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <Content />
    </Modal>
  );
};

const Content = () => {
  return (
    <div className={styles.liquidGranularInfoModal}>
      <div className={styles.liquidBlock}>
        <h2>Why liquid fertilizer?</h2>
        <ul>
          <li>All you need is a hose</li>
          <li>Easy 10 minute application</li>
          <li>Fast results and green up</li>
        </ul>
      </div>
      <div className={styles.imageBlock}>
        <div className={styles.imageContainer}>
          <img
            src="/images/liquid-granular-modal/liquid.jpg"
            srcSet="/images/liquid-granular-modal/liquid.jpg 1x, /images/liquid-granular-modal/liquid@2x.jpg 2x"
            alt="Homeowner spraying Sunday liquid fertilizer on their lawn"
            width="200"
            height="200"
            className={styles.liquidImage}
          />
        </div>
        <div className={styles.imageContainer}>
          <img
            src="/images/liquid-granular-modal/granular.jpg"
            srcSet="/images/liquid-granular-modal/granular.jpg 1x, /images/liquid-granular-modal/granular@2x.jpg 2x"
            alt="Homeowner spreading Sunday granular fertilizer on their lawn"
            width="200"
            height="200"
            className={styles.granularImage}
          />
        </div>
        <div className={styles.imageOverlay}>OR</div>
      </div>
      <div className={styles.granularBlock}>
        <h2>Why granular fertilizer?</h2>
        <ul>
          <li>Same guaranteed results</li>
          <li>Fewer applications per year</li>
          <li>Apply with a spreader</li>
        </ul>
      </div>
    </div>
  );
};

export default LiquidGranularInfoModal;
